import React, { useEffect, useState } from 'react'
import { User, UserContext } from '../context/UserContext'
import { participantApiV1 } from '../api'

interface UserProviderProps {
  children: React.ReactNode
}

const UserProvider: React.FC<UserProviderProps> = ({ children }) => {
  const [currentUser, setCurrentUser] = useState<User | null>(null)

  useEffect(() => {
    const fetchUser = async () => {
      const token = localStorage.getItem('token')

      if (!currentUser && window.location.pathname !== '/auth') {
        if (token) {
          participantApiV1.defaults.headers.common['Authorization'] = token

          try {
            const response = await participantApiV1.get('/participants/me', {
              headers: {
                Authorization: token
              }
            })

            setCurrentUser(response.data)
          } catch (err) {
            console.log('get me error', err)
            window.location.replace('/auth')
          }
        } else {
          window.location.replace('/auth')
        }
      }
    }

    fetchUser()
  }, [currentUser])

  return (
    <UserContext.Provider value={{ currentUser, setCurrentUser }}>{children}</UserContext.Provider>
  )
}

export default UserProvider
